export default __webpack_public_path__ + "static/char-s-10-chs-5c69861a11ed7d96be9f5071fab07e7e.png";